import { Injectable } from '@angular/core';
import { HttpClientService } from '@app/core/http-client/http-client.service';
import { services } from '@app/core/settings';
import { TermsAndConditions } from '@app/shared/models/TermsAndConditions';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TermsAndConditionsService {

  private static readonly endpoint = 'TermsAndConditions';
  constructor(private http: HttpClientService) { }

  get(id: number): Observable<any> {
    return this.http.get<any>(`${TermsAndConditionsService.endpoint}/GetTermsAndConditionsById/${id}`, undefined, services.orderService);
  }

  getFirstTermsAndConditioins(): Observable<any> {
    return this.http.get<any>(`${TermsAndConditionsService.endpoint}/GetFirstTermsAndConditions`, undefined, services.orderService);
  }

  list(body: Object): Observable<any> {
    return this.http.post(body, `${TermsAndConditionsService.endpoint}/GetTermsAndConditionsPaginated`, undefined, services.orderService)
  }

  create(model: TermsAndConditions): Observable<any> {
    return this.http.post(model, `${TermsAndConditionsService.endpoint}/Create`, undefined, services.orderService);
  }

  update(model: TermsAndConditions): Observable<any> {
    return this.http.put(model, `${TermsAndConditionsService.endpoint}/Update`, services.orderService);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${TermsAndConditionsService.endpoint}/Delete/${id}`, undefined, services.orderService);
  }
}
